import { useState } from "react";

export default function IngredientSelectMessage({ ingredients, onSubmit }) {
  const [selected, setSelected] = useState(new Set(ingredients));

  const toggle = (item) => {
    const next = new Set(selected);
    if (next.has(item)) next.delete(item);
    else next.add(item);
    setSelected(next);
  };

  return (
    <div>
      <ul className="space-y-1 mb-2">
        {ingredients.map((item) => (
          <li key={item}>
            <label className="flex items-center gap-2 text-gray-600">
              <input
                type="checkbox"
                checked={selected.has(item)}
                onChange={() => toggle(item)}
              />
              <span>{item}</span>
            </label>
          </li>
        ))}
      </ul>
      <button
        onClick={() => onSubmit(Array.from(selected))}
        className="w-full bg-charcoal text-white text-sm py-1.5 rounded"
      >
        Use These Ingredients
      </button>
    </div>
  );
}
